import React, { useContext } from 'react'
import Head from 'next/head'
import { ServerSidePropsContext } from 'providers/ServerSideProps'

import { useAuthor } from './author'
import { useCanonical } from './canonical'
import { useDescription } from './description'
import { useFacebookSEO } from './facebook'
import { useKeywords } from './keywords'
import { useOpenGraphProtocol } from './ogp'
import { useOpenGraphArticle } from './ogp/article'
import { useOpenGraphImages } from './ogp/image'
import { useRobots } from './robots'
// import { useArticleSchema } from './schemas/article'
// import { useOrganizationSchema } from './schemas/organization'
// import { useWebPage } from './schemas/webpage'
// import { useWebSite } from './schemas/website'
import { useSeoStrategy } from './strategy'
import { useTitle } from './title'
import { useTwitterSEO } from './twitter'
import { useAppleTouchIconMetatags } from './useAppleTouchIconMetatags'
import { useGoogleFonts } from './useGoogleFonts'
import { useIconMetatags } from './useIconMetatags'
import { useManifest } from './useManifest'
import { useMobileConfig } from './useMobileConfig'
import { useSplashScreen } from './useSplashScreen'
import { useViewport } from './viewport'
import { SeoProviderProps } from './types'
// import { useGjcAnalyticsTags } from './gjcAnalytics'

const SeoProvider = ({ children }: SeoProviderProps) => {
  const data = useSeoStrategy()
  const serverSideContext = useContext(ServerSidePropsContext)

  return (
    <React.Fragment>
      <Head>
        {useAppleTouchIconMetatags({ enabled: true, favicons: serverSideContext.siteConfig.assets.favicons, site: serverSideContext.siteConfig })}
        {useAuthor({ enabled: true, ...data?.author })}
        {useCanonical({ enabled: true, ...data?.canonical })}
        {useDescription({ enabled: true, ...data?.description })}
        {useFacebookSEO({ enabled: true, ...data?.facebook })}
        {/*{useGjcAnalyticsTags({ enabled: false, ...data?.gjcAnalytics })}*/}
        {useIconMetatags({ enabled: true, favicons: serverSideContext.siteConfig.assets.favicons, site: serverSideContext.siteConfig })}
        {useKeywords({ enabled: true, ...data?.keywords })}
        {useManifest({ enabled: true, site: serverSideContext.siteConfig.slug })}
        {useMobileConfig({ enabled: true })}
        {useOpenGraphArticle({ enabled: true, ...data?.openGraphArticle })}
        {useOpenGraphImages({ enabled: true, ...data?.openGraphImages })}
        {useOpenGraphProtocol({ enabled: true, ...data?.openGraph })}
        {useRobots({ enabled: true, ...data?.robots })}
        {useSplashScreen({ enabled: true, site: serverSideContext.siteConfig.slug, splashScreens: serverSideContext.siteConfig.assets.splashScreens })}
        {useTitle({ enabled: true, ...data?.title })}
        {useTwitterSEO({ enabled: true, ...data?.twitter })}
        {useViewport({ enabled: true, ...data?.viewport })}
        {useGoogleFonts({ enabled: true, slug: serverSideContext.siteConfig.slug })}
        {/* Schemas */}
        {/* Desabilitado para o formato server side rendering - Remover caso o Server Side Rendering resolva os problemas de indexação*/}
        {/*{useOrganizationSchema({ enabled: data?.schemas?.enabled || false, ...data?.schemas?.organization })}*/}
        {/*{useWebPage({ enabled: data?.schemas?.enabled || false, ...data?.schemas?.webpage })}*/}
        {/*{useWebSite({ enabled: data?.schemas?.enabled || false, ...data?.schemas?.website })}*/}
        {/*{useArticleSchema({ enabled: data?.schemas?.enabled || false, ...data?.schemas?.article })}*/}
      </Head>
      {children}
    </React.Fragment>
  )
}

export default SeoProvider
